import React, { useEffect, useState } from "react";

import { NumericProps, numericInputRegex } from "../../utils/numeric";

import TextInput, { TextInputProps } from "./TextInput";

/**
 * This component allows you to accept numeric entry according to
 * a format you specify. It will not PREVENT a user from typing
 * invalid characters, but it will (by default) not send an onChange
 * event if the input is invalid. You can override this behavior by
 * setting allowInvalidEntry to true (which will still yell at the user,
 * but will send the onChange event anyway).
 *
 * Allowing the user to (temporarily) type invalid numbers is useful
 * for a better user experience, since it prevent the input from changing
 * while the user is still typing (which would be very annoying) such as
 * entering a `-` before you enter a number
 */
type NumericTextInputProps = TextInputProps & NumericProps;

const NumericTextInput = React.forwardRef<
  HTMLInputElement,
  NumericTextInputProps
>((props, ref) => {
  const regex = numericInputRegex(props);

  const [
    intermediateStringRepresentation,
    setIntermediateStringRepresentation,
  ] = useState(props.value);

  useEffect(() => {
    setIntermediateStringRepresentation(props.value);
  }, [props.value]);

  return (
    <TextInput
      {...props}
      onChange={(e) => {
        if (
          props.allowInvalidEntry ||
          e.target.value.match(new RegExp(regex))
        ) {
          props.onChange?.(e);
        }
        setIntermediateStringRepresentation(e.target.value);
      }}
      pattern={regex}
      ref={ref}
      selectOnFocus
      value={intermediateStringRepresentation}
    />
  );
});

export default NumericTextInput;
